import { ButtonERP } from "@finanedi.es/storybook"
import { PerceptorGetDatosDeclaracionModelo180DtoProps } from "api/DTOs/PerceptorGetDatosDeclaracionModelo180Dto"
import { FieldErrors, UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import PerceptorsTemplate180 from "./PerceptorsTemplate180"

export interface MyFormValuesModelo180 {
  perceptores: Array<{
    modalidad: string
    situacionInmueble: string
    tipoVia: string
    tipoNumeracion: string
    provinciaDos: string
  }>
}

const Perceptores180 = ({
  setValue,
  watch,
  errors,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValue: UseFormSetValue<any>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  watch: UseFormWatch<any>
  errors: FieldErrors<MyFormValuesModelo180>
}) => {
  const { t } = useTranslation()
  const values = watch()
  const perceptorsCount = values?.perceptores?.length ?? 1
  const handleAddPerceptor = () => {
    const current = Array.isArray(values?.perceptores) ? values.perceptores : []
    const newPerceptor = {}
    setValue("perceptores", [...current, newPerceptor], {
      shouldValidate: false,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  const handleDeletePerceptor = (index: number) => {
    const current = Array.isArray(values?.perceptores) ? values.perceptores : []
    const updated = current.filter(
      (_: PerceptorGetDatosDeclaracionModelo180DtoProps, idx: number) =>
        idx !== index
    )
    setValue("perceptores", updated, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    })
  }

  return (
    <div
      title='Perceptores180'
      className='tw-w-full tw-px-4 tw-pb-4 tw-space-y-3'
    >
      <ButtonERP
        label={`${t("taxSummary.declaracion.addPerceptor")}`}
        customize={{ type: "primary", size: "md" }}
        onClick={handleAddPerceptor}
      />

      {Array.from({ length: perceptorsCount }).map((_, index) => (
        <PerceptorsTemplate180
          t={t}
          // eslint-disable-next-line react/no-array-index-key
          key={`perceptors_${index}`}
          text={`${t("declaracionModelo180.perceptors.perceptor")} ${
            index + 1
          }`}
          values={values}
          setValue={setValue}
          perceptorIndex={index}
          handleDelete={() => handleDeletePerceptor(index)}
          errors={errors}
        />
      ))}
    </div>
  )
}

export default Perceptores180
